import { gql } from '@apollo/client'

import { BOX_ORDER_SUMMARY_MODAL_FRAGMENT } from '@/components/modals/OrderSummaryModal/fragments'

const REVIEW_PLAN_CHANGES_MUTATION = gql`
  ${BOX_ORDER_SUMMARY_MODAL_FRAGMENT}
  mutation ReviewPlanChangesMutation(
    $userId: ID!
    $planId: ID!
    $nextNBoxesNum: Int!
  ) {
    subscriptionPlanUpdate(userId: $userId, planId: $planId) {
      id
      subscription {
        id
        plan {
          id
          numberOfPouches
          durationInWeeks
          pricePerDay
          pouchSize
          servingInformation {
            gramsPerDay
          }
        }
        nextNBoxes(num: $nextNBoxesNum) {
          id
          numberOfPouches
          durationInDays
          isoDeliveryDate
          editable
          plan {
            id
            pouchSize
          }
          ...BoxOrderSummaryModalFragment
        }
      }
    }
  }
`

export { REVIEW_PLAN_CHANGES_MUTATION }
